/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Empty_TranscriptInputs */

const en_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent captions will appear here.`)
};

const fr_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les légendes envoyées apparaîtront ici.`)
};

const de_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesendeten Untertitel werden hier angezeigt.`)
};

const it_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le didascalie inviate appariranno qui.`)
};

const ru_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присланные субтитры появятся здесь.`)
};

const es_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los subtítulos enviados aparecerán aquí.`)
};

const zh_cn2_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送的字幕将显示在此处。`)
};

const ja_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信された字幕はここに表示されます。`)
};

const hi_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भेजे गए कैप्शन यहां दिखाई देंगे।`)
};

const pt_pt2_live_caption_empty_transcript = /** @type {(inputs: Live_Caption_Empty_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As legendas enviadas aparecerão aqui.`)
};

/**
* | output |
* | --- |
* | "Sent captions will appear here." |
*
* @param {Live_Caption_Empty_TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_empty_transcript = /** @type {((inputs?: Live_Caption_Empty_TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Empty_TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_empty_transcript(inputs)
	if (locale === "de") return de_live_caption_empty_transcript(inputs)
	if (locale === "it") return it_live_caption_empty_transcript(inputs)
	if (locale === "ru") return ru_live_caption_empty_transcript(inputs)
	if (locale === "es") return es_live_caption_empty_transcript(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_empty_transcript(inputs)
	if (locale === "ja") return ja_live_caption_empty_transcript(inputs)
	if (locale === "hi") return hi_live_caption_empty_transcript(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_empty_transcript(inputs)
	return en_live_caption_empty_transcript(inputs)
});